<template>
  <div class="ax-head-box">
    <div class="head_content">
      <div class="ing_box">
        <slot name="ing"></slot>
      </div>
      <div class="over_box">
        <slot name="over"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { clearTimeout } from 'timers';
  export default {
    name: "ax-head",
    props: {
      title: [String],
      fold: {
        type: Boolean,
        default: true
      },
      noTitle: {
        type: Boolean,
        default: false
      },
      backgroundColor: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        active: true,
      }
    }
  }
</script>

<style lang="scss" scoped>
.ax-head-box {
  margin-bottom: 8px;
  padding: 16px 16px 16px;
  background-color: #fff;
  .head_content {
    margin: 0 auto;
  }
  .ing_box {
    color: $head-color;
    line-height: 20px;
    font-size: 14px;
    em {
      font-style: normal;
      color: $link_a;
    }
  }
  .over_box {
    color: $head-color;
    line-height: 20px;
    font-size: 14px;
  }
}
</style>
